"use client";
import ButtonSubmit from "@/components/FormSubmitButton";
import FormInput from "@/components/FormInput";
import apiAxios from "@/utils/api/apiAxios";
import Cookies from "js-cookie";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { toast } from "sonner";
import FormInputPassword from "@/components/FormInputPassword";

const FormLogin = () => {
  const router = useRouter();
  const params = useSearchParams();
  const token = params.get("token");
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Menangani perubahan input
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    await apiAxios
      .post("/login", formData)
      .then((res) => {
        toast.success("Login Berhasil");
        Cookies.set("token", res.token);
        // console.log(window.opener)

        if (window.opener) {
          console.log("Sending message to parent window");

          window.opener.postMessage(
            { type: "LOGIN_SUCCESS", token: res.token },
            process.env.NEXT_PUBLIC_SITE_URL
          );
          window.close();
        } else {
          return router.push("/u");
        }
      })
      .catch((err) => {
        setErrors(err?.errors);
        if (err?.data?.status_code === 401) {
          router.replace("/verifikasi?email=" + err?.data?.email);
        } else {
          toast.error(err?.message || "Login Gagal");
          setIsSubmitting(false);
        }
      });
  };

  useEffect(() => {
    const expectedOrigin = process.env.NEXT_PUBLIC_SITE_URL;
    const handleMessage = (event) => {
      // Validasi asal pesan untuk keamanan
      if (event.origin !== expectedOrigin) return;
      const { type } = event.data;
      if (type === "LOGIN_SUCCESS") {
        return router.push("/u");
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [router]);

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div>
        <FormInput
          label={"Username atau Email"}
          name={"username"}
          handleChange={handleChange}
          disabled={isSubmitting}
          value={formData.username}
          error={errors?.username}
        />
      </div>

      <div>
        <FormInputPassword
          label={"Password"}
          name={"password"}
          value={formData.password}
          handleChange={handleChange}
          disabled={isSubmitting}
          error={errors?.password}
        />
      </div>

      <div className="flex items-center justify-between">
        <div className="flex gap-3">
          <div className="flex h-6 shrink-0 items-center">
            <div className="group grid size-4 grid-cols-1">
              <input
                id="remember-me"
                name="remember-me"
                type="checkbox"
                className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-amber-500 checked:bg-amber-500 indeterminate:border-amber-500 indeterminate:bg-amber-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-amber-500 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
              />
              <svg
                fill="none"
                viewBox="0 0 14 14"
                className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-[:disabled]:stroke-gray-950/25"
              >
                <path
                  d="M3 8L6 11L11 3.5"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="opacity-0 group-has-[:checked]:opacity-100"
                />
                <path
                  d="M3 7H11"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="opacity-0 group-has-[:indeterminate]:opacity-100"
                />
              </svg>
            </div>
          </div>
          <label
            htmlFor="remember-me"
            className="block text-sm/6 text-gray-900"
          >
            Remember me
          </label>
        </div>

        <div className="text-sm/6">
          <Link
            href="/forgot-password"
            className="font-semibold text-amber-500 hover:text-amber-400"
          >
            Forgot password?
          </Link>
        </div>
      </div>

      <div className="">
        <ButtonSubmit full={true} isSubmitting={isSubmitting}>
          Login
        </ButtonSubmit>
        <p className="mt-2 text-sm font-light italic text-gray-500">
          Belum memiliki akun?{" "}
          <Link
            href="/register"
            className="font-semibold  hover:text-slate-900"
          >
            Daftar
          </Link>
        </p>
      </div>
    </form>
  );
};

export default FormLogin;
